// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"15d02036","917":"95893981"}[chunkId] + ".chunk.js";
};